export default __webpack_public_path__ + "static/media/034-sailor-cap.a57b7459.png";